"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var PhoneCall = function PhoneCall(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M17.663 18.163a.587.587 0 01-.573.407c-1.127-.023-4.258-.433-7.738-3.914-3.481-3.48-3.89-6.612-3.914-7.74a.587.587 0 01.407-.571l2.671-.872a.61.61 0 01.745.339l1.066 2.47a.596.596 0 01-.122.66l-1.252 1.252a.294.294 0 00-.068.312 7.293 7.293 0 001.802 2.815 7.294 7.294 0 002.815 1.802c.108.04.23.014.312-.068l1.252-1.252a.596.596 0 01.66-.122l2.47 1.066a.609.609 0 01.339.744l-.872 2.672z"
  }));
};

var _default = (0, _react.forwardRef)(PhoneCall);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PhoneCall, "PhoneCall", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneCall.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneCall.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();